import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { HttpException } from '../../../../exceptions/index';
import { useAppMutation } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';

/**
 * The Vault as a zip through the Vault's own routes: the folder open, or — at the top level, which
 * is no folder — the whole Repository.
 */
export const useVaultArchive = () => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { isPending, mutate } = useAppMutation<void, HttpException, { folderId: null | string }>(
    [QueryKey.VAULT_ARCHIVE, companyId],
    {
      mutationFn: async ({ folderId }) => {
        await ApiService.downloadFile({
          endpoint: BackendRoute.COMPANIES,
          routePath: folderId
            ? [companyId, 'vault', 'folders', folderId, 'export']
            : [companyId, 'vault', 'repository', 'export'],
        });
      },
    },
  );

  return {
    downloadVaultArchive: (folderId: null | string) => mutate({ folderId }),
    isPending,
  };
};
